import React, { useState, useEffect } from 'react'
import ContactForm from '../components/ContactForm'

export default function AppPage() {
  const [pageData, setPageData] = useState(null)

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/by-slug/da/app')
      .then(res => res.json())
      .then(data => {
        if (data) {
          setPageData(data)
          document.title = `${data.title} - Frejlev Auto v/ Jacob Kvist`
        }
      })
      .catch(err => console.error('Error fetching app page:', err))
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 py-12 md:py-16 text-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* App Content */}
          <div className="lg:col-span-7 space-y-8">
            <div className="bg-white p-6 sm:p-10 rounded-2xl border border-gray-200 shadow-sm space-y-6">
              {pageData ? (
                <div className="rich-text">
                  <div 
                    dangerouslySetInnerHTML={{ 
                      __html: pageData.content.replace(/<h1[^>]*>.*?<\/h1>/i, '') 
                    }}
                  />
                </div>
              ) : (
                <div className="animate-pulse space-y-4">
                  <div className="h-8 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-4 bg-gray-200 rounded w-full"></div>
                  <div className="h-4 bg-gray-200 rounded w-5/6"></div>
                  <div className="h-4 bg-gray-200 rounded w-2/3"></div>
                </div>
              )}
            </div>

            {/* App Download Buttons & QR Code Placeholder */}
            <div className="bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 space-y-6 shadow-sm">
              <h3 className="text-xl font-bold text-gray-900">Hent appen i dag</h3>
              <p className="text-gray-600 text-sm leading-relaxed">
                Scan QR-koden med dit mobilkamera for at gå direkte til download, eller brug knapperne nedenfor til at finde appen i din foretrukne app store.
              </p>

              <div className="flex flex-col sm:flex-row items-center gap-6 pt-2">
                {/* QR Code Graphic */}
                <div className="w-36 h-36 bg-gray-50 p-3 rounded-xl flex items-center justify-center shrink-0 border border-gray-200 shadow-inner">
                  <div className="w-full h-full border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center text-gray-400">
                    <i className="fa-solid fa-qrcode text-4xl mb-1 text-gray-600"></i>
                    <span className="text-[10px] uppercase tracking-wider font-bold">QR Kode</span>
                  </div>
                </div>

                {/* Download Buttons */}
                <div className="flex flex-col gap-3 w-full sm:w-auto">
                  <button
                    disabled
                    className="px-5 py-3 bg-gray-50 border border-gray-200 rounded-lg text-xs text-gray-500 font-semibold flex items-center gap-3 hover:bg-gray-100 transition-all cursor-not-allowed"
                  >
                    <i className="fa-brands fa-apple text-xl text-black"></i>
                    <div className="text-left">
                      <p className="text-[10px] uppercase text-gray-400 font-bold leading-none">Hent i</p>
                      <p className="text-black text-sm font-bold mt-0.5">App Store</p>
                    </div>
                  </button>

                  <button
                    disabled
                    className="px-5 py-3 bg-gray-50 border border-gray-200 rounded-lg text-xs text-gray-500 font-semibold flex items-center gap-2 hover:bg-gray-100 transition-all cursor-not-allowed"
                  >
                    <i className="fa-brands fa-google-play text-xl text-black"></i>
                    <div className="text-left">
                      <p className="text-[10px] uppercase text-gray-400 font-bold leading-none">Hent i</p>
                      <p className="text-black text-sm font-bold mt-0.5">Google Play</p>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Support Contact Form */}
          <div className="lg:col-span-5">
            <ContactForm subject="Spørgsmål til appen" />
          </div>
        </div>
      </div>
    </div>
  )
}
